export function init() {
    if (document.getElementById('uld')) {
        const token = document.getElementById("Token").value;
        const cultureId = document.getElementById("LanguageCultureId").value;
        const uld = document.getElementById("uld").value;

        var form = document.createElement("form");
        form.setAttribute("method", "post")
        form.setAttribute("action", "https://fastcalc.dialux.com/")
        form.setAttribute("target", "fastCalcFrame")

        var formData = [
            { name: "uld", value: uld },
            { name: "lcid", value: cultureId},
            { name: "st", value: token }
        ]

        formData.forEach(function (item) {
            var hiddenField = document.createElement("input");
            hiddenField.setAttribute("type", "hidden");
            hiddenField.setAttribute("name", item.name);
            hiddenField.setAttribute("value", item.value);

            form.appendChild(hiddenField);
        })

        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
    }
}